import { ResourceIconCategoryFront } from '../domain/models/resources.model';

/**
 * Maps a MIME type to a resource icon category for UI display purposes.
 * @param mimeType - The MIME type string (e.g., 'image/png', 'application/pdf')
 * @returns The corresponding ResourceIconCategoryFront enum value
 */
export function mapMimeTypeToIconCategory(mimeType: string): ResourceIconCategoryFront {
  const primaryType = mimeType.split('/')[0];

  switch (primaryType) {
    case 'image':
      return ResourceIconCategoryFront.IMAGE;
    case 'audio':
      return ResourceIconCategoryFront.AUDIO;
    case 'video':
      return ResourceIconCategoryFront.VIDEO;
    case 'text':
      return ResourceIconCategoryFront.TEXT;
    case 'application':
      if (mimeType.includes('pdf') || mimeType.includes('json') || mimeType.includes('xml')) {
        return ResourceIconCategoryFront.TEXT;
      }
      if (
        mimeType.includes('zip') ||
        mimeType.includes('tar') ||
        mimeType.includes('gzip') ||
        mimeType.includes('rar')
      ) {
        return ResourceIconCategoryFront.PACKAGE;
      }
      return ResourceIconCategoryFront.PACKAGE;
    default:
      return ResourceIconCategoryFront.DEFAULT;
  }
}
